<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 col-md-6 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Question Name"
          :rules="[(v) => !!v || 'Name is Required']"
        ></q-input>
      </div>
      <div class="col-12 col-md-6 q-px-sm">
        <q-input
          label="Label"
          :rules="[(v) => !!v || 'Label is Required']"
          v-model="formData.message"
        >
        </q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input label="Category" v-model="formData.category"> </q-input>
      </div>

      <div class="col-12 col-md-6 q-px-sm">
        <q-input label="Unit" v-model="formData.unit"> </q-input>
      </div>
      <div class="col-12 col-md-6 q-px-sm">
        <q-select
          v-model="formData.status"
          :emit-value="true"
          map-options
          label="Status"
          :options="statusOptions"
        ></q-select>
      </div>
      <div class="col-12 q-px-sm">
        <assignOutcome
          :id="formData.outcomes_id"
          @changed="(val) => (formData.outcomes_id = val)"
        />
      </div>
      <div class="col-12 q-px-sm">
        <q-input label="Tooltip" type="textarea" v-model="formData.tooltip">
        </q-input>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignOutcome from "@/components/outcomes/assignOutcome.vue";

export default {
  components: {
    assignOutcome,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
    }),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
    file: function () {
      if (this.file != null) {
        this.uploadThumbnailReady();
      }
    },
  },
  data: () => ({
    // Extra Data
    formData: {},
    statusOptions: [
      {
        label: "Hidden",
        value: "hidden",
      },
      {
        label: "Visible",
        value: "visible",
      },
    ],

    myCroppa: {},

    file: null,
    uploadThumbnailLoading: false,
  }),
  beforeCreate() {
    this.$store.dispatch("questions/loadAll");
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {
          status: "visible",
          // unit: "tonnes",
          // category: "Sources Type : Other",
          // outcomes_id: 6,
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$store
            .dispatch("questions/new", this.formData)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);
      this.$store.dispatch("questions/save", this.formData).then((result) => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.address = "";
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      });
    },

    // SVG UPload

    uploadThumbnail() {
      this.$refs.uploadThumbnailInput.$el.click();
      this.uploadThumbnailLoading = true;
    },
    uploadThumbnailReady() {
      let reader = new FileReader();
      reader.readAsDataURL(this.file[0]);
      reader.onload = () => {
        this.$store
          .dispatch("questions/uploadThumbnail", {
            id: this.formData.id,
            data: reader.result,
          })
          .then((res) => {
            this.$q.notify({
              message: "Thumbnail Saved",
              color: "positive",
            });
            this.file = null;
            this.uploadThumbnailLoading = false;
            this.formData.imgUrl = res.Response.DownloadUrl;
          });
      };
    },
  },
};
</script>
